import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";
import { ICateringOrder } from "./CateringOrderRepository";

export class GetNewCateringOrdersEndpoint implements IGetNewCateringOrdersEndpoint
{
    public async execute(nodeId: number, spaceId: string): Promise<ICateringOrder[]>
    {
        try
        {
            const response: AxiosResponse<ICateringOrder[]> = await axios.get(`${apis.allApiv2}${nodeId}/catering-order/${spaceId}/new-order-items`);
            return response.data;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IGetNewCateringOrdersEndpoint
{
    execute(nodeId: number, spaceId: string): Promise<ICateringOrder[]>;
}
